import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {MoreFetcher} from "./more_fetcher";

export const moreFetcherLoader = function (options = {}) {
    componentLoader(componentConfig(MoreFetcher, MoreFetcher.config.componentTypeKey, MoreFetcher.config.baseHtmlClass), options);
};
